<template>
    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field
                v-model="fields.name"
                label="Nome"
                :disabled="disabled"
                :rules="[$rules.required]"
                outlined
                dense
                hide-details="auto"
            />
        </v-col>
        <v-col v-if="withRegistration" cols="12" sm="6">
            <v-text-field
                v-model="fields.registration"
                label="CPF"
                v-mask="$masks.cpf"
                inputmode="numeric"
                :disabled="disabled"
                :rules="[$rules.required, $rules.cpf]"
                outlined
                dense
                hide-details="auto"
            />
        </v-col>
        <v-col v-if="withOab" cols="12" sm="6">
            <v-text-field
                v-model="fields.oab"
                label="Nº da OAB com a seccional"
                :disabled="disabled"
                :rules="[$rules.required]"
                outlined
                dense
                hide-details="auto"
            />
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field
                v-model="fields.email"
                label="E-mail"
                type="email"
                :disabled="disabled"
                :rules="[$rules.required, $rules.email]"
                outlined
                dense
                hide-details="auto"
            />
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field
                v-model="fields.phone_number"
                label="Telefone"
                type="tel"
                v-mask="$masks.phone"
                :disabled="disabled"
                :rules="[$rules.required, $rules.phone]"
                outlined
                dense
                hide-details="auto"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'PersonFields',
    props: {
        person: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
        withRegistration: { type: Boolean, default: false },
        withOab: { type: Boolean, default: false }
    },
    data() {
        // Alias do objeto do pai: os campos são editados no próprio objeto recebido.
        return { fields: this.person };
    },
    watch: {
        person(next) {
            this.fields = next;
        }
    }
};
</script>
